import React from 'react';
import Header from '../components/Husk-n-spices/Header';
import ListItem from '../components/ListItem';
import { data } from '../HusknSpicesData/ProductFeedGradeVegetableAndGrainPowder';
import Footer from '../components/Husk-n-spices/Footer';

export default function HerbalProducts() {
  return (
    <div id="wrapperParallax" className="wrapper wrapper-boxed clearfix">
      <Header />
      {data
        .filter(i => i.type === 'Spice')
        .map(spice => {
          return (
            <ListItem
              name={spice.name || 'No Name'}
              description={spice.description || 'No Description'}
              ingredientValues={spice.ingredientValues || 'No Ingredient Values'}
              image={spice.image}
              id={spice.id}
            />
          );
        })}
      <Footer />
    </div>
  );
}
